"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrameEnd = exports.Event = exports.FrameStart = exports.LoggedEvent = exports.SequentialItem = exports.LoggedEventList = exports.AppType = exports.BlizzardEventSource = exports.PageTabType = exports.ConnectivityType = exports.AppVariant = exports.OperatingSystem = exports.DeviceModel = exports.Locale = exports.EventName = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
/**
 * THIS IS STILL UNDER ACTIVE DEVELOPMENT.
 * TODO(sbruce) place enums in namespaces.
 * Needs a canonical generated location.
 * Present here to allow development.
 */
var EventName;
(function (EventName) {
    /** APP_APPLICATION_OPEN - First 128 slots reserved for tier0 events. */
    EventName[EventName["APP_APPLICATION_OPEN"] = 0] = "APP_APPLICATION_OPEN";
    EventName[EventName["APP_APPLICATION_CLOSE"] = 1] = "APP_APPLICATION_CLOSE";
    EventName[EventName["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(EventName = exports.EventName || (exports.EventName = {}));
var Locale;
(function (Locale) {
    /**
     * EN - beyond scope of this file.  Intermediate step is to store as text
     * in FrameStart.
     */
    Locale[Locale["EN"] = 0] = "EN";
    Locale[Locale["EN_US"] = 1] = "EN_US";
    Locale[Locale["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Locale = exports.Locale || (exports.Locale = {}));
/** Needs a canonical generated location. */
var DeviceModel;
(function (DeviceModel) {
    DeviceModel[DeviceModel["UNKNOWN"] = 0] = "UNKNOWN";
    DeviceModel[DeviceModel["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(DeviceModel = exports.DeviceModel || (exports.DeviceModel = {}));
var OperatingSystem;
(function (OperatingSystem) {
    /** ANDROID - android default for obvious reasons. */
    OperatingSystem[OperatingSystem["ANDROID"] = 0] = "ANDROID";
    OperatingSystem[OperatingSystem["IOS"] = 1] = "IOS";
    /** OPERATING_SYSTEM_OTHER - A OS was detected but we don't have a mapping for it, check the user_agent field */
    OperatingSystem[OperatingSystem["OPERATING_SYSTEM_OTHER"] = 2] = "OPERATING_SYSTEM_OTHER";
    OperatingSystem[OperatingSystem["OPERATING_SYSTEM_WINDOWS"] = 3] = "OPERATING_SYSTEM_WINDOWS";
    /** OPERATING_SYSTEM_OSX - MacOS ("OSX" for backwards compatibility) */
    OperatingSystem[OperatingSystem["OPERATING_SYSTEM_OSX"] = 4] = "OPERATING_SYSTEM_OSX";
    /** OPERATING_SYSTEM_CHROMIUM_OS - note: stringifed to "CHROMIUM OS" not "CHROMIUM_OS" for backwards-compatibility */
    OperatingSystem[OperatingSystem["OPERATING_SYSTEM_CHROMIUM_OS"] = 5] = "OPERATING_SYSTEM_CHROMIUM_OS";
    OperatingSystem[OperatingSystem["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(OperatingSystem = exports.OperatingSystem || (exports.OperatingSystem = {}));
/** Variant of the android app in use. */
var AppVariant;
(function (AppVariant) {
    AppVariant[AppVariant["MUSHROOM"] = 0] = "MUSHROOM";
    /** OG - dead in production. */
    AppVariant[AppVariant["OG"] = 1] = "OG";
    /** HMS - Huawei Mobile Services, see https://docs.google.com/document/d/11bdjtI1IJyo5RdxMk_BigE_3AedqLHY7YHMIJd5AtEw */
    AppVariant[AppVariant["HMS"] = 2] = "HMS";
    /** LOCKSCREEN - Lock Screen Mode (Catalina), see go/blizzard-catalina */
    AppVariant[AppVariant["LOCKSCREEN"] = 3] = "LOCKSCREEN";
    AppVariant[AppVariant["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AppVariant = exports.AppVariant || (exports.AppVariant = {}));
/**
 * The names of these match the names of the JSON enums so we can just
 * get the string of the enum to convert in collector.
 */
var ConnectivityType;
(function (ConnectivityType) {
    ConnectivityType[ConnectivityType["UNKNOWN_CONNECTIVITY_TYPE"] = 0] = "UNKNOWN_CONNECTIVITY_TYPE";
    ConnectivityType[ConnectivityType["WIFI"] = 1] = "WIFI";
    ConnectivityType[ConnectivityType["MOBILE"] = 2] = "MOBILE";
    ConnectivityType[ConnectivityType["UNREACHABLE"] = 3] = "UNREACHABLE";
    ConnectivityType[ConnectivityType["BLUETOOTH"] = 4] = "BLUETOOTH";
    /** CONNECTIVITY_TYPE_ETHERNET - currently only reported by web */
    ConnectivityType[ConnectivityType["CONNECTIVITY_TYPE_ETHERNET"] = 5] = "CONNECTIVITY_TYPE_ETHERNET";
    ConnectivityType[ConnectivityType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ConnectivityType = exports.ConnectivityType || (exports.ConnectivityType = {}));
/**
 * An id used to attribute an event to a navigational feature tab. For more details, please see the design doc:
 * https://docs.google.com/document/d/1tKmsY6CP_OLf1-dtF9sEBM2cXcAZDv9FkUZ-MScMvTE/edit?usp=sharing
 */
var PageTabType;
(function (PageTabType) {
    PageTabType[PageTabType["UNKNOWN_PAGE_TAB_TYPE"] = 0] = "UNKNOWN_PAGE_TAB_TYPE";
    PageTabType[PageTabType["MAPS"] = 1] = "MAPS";
    PageTabType[PageTabType["CHAT"] = 2] = "CHAT";
    PageTabType[PageTabType["CAMERA"] = 3] = "CAMERA";
    PageTabType[PageTabType["DISCOVER"] = 4] = "DISCOVER";
    PageTabType[PageTabType["SPOTLIGHT"] = 5] = "SPOTLIGHT";
    PageTabType[PageTabType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PageTabType = exports.PageTabType || (exports.PageTabType = {}));
/**
 * Where this event was first created. Events can be created within Composer, the iOS Extension, or Native,
 * and then passed to platform code for logging alongside other events. It will be useful to be able to determine
 * where an event originated when performing analysis or alerting.
 */
var BlizzardEventSource;
(function (BlizzardEventSource) {
    /** BLIZZARD_EVENT_SOURCE_PLATFORM - This will not be set on the client, instead the field will be omitted to save space. */
    BlizzardEventSource[BlizzardEventSource["BLIZZARD_EVENT_SOURCE_PLATFORM"] = 0] = "BLIZZARD_EVENT_SOURCE_PLATFORM";
    /** BLIZZARD_EVENT_SOURCE_NATIVE - This is the native c++ code in the client repo */
    BlizzardEventSource[BlizzardEventSource["BLIZZARD_EVENT_SOURCE_NATIVE"] = 1] = "BLIZZARD_EVENT_SOURCE_NATIVE";
    /** BLIZZARD_EVENT_SOURCE_COMPOSER - Typescript code also in the client repo */
    BlizzardEventSource[BlizzardEventSource["BLIZZARD_EVENT_SOURCE_COMPOSER"] = 2] = "BLIZZARD_EVENT_SOURCE_COMPOSER";
    /** BLIZZARD_EVENT_SOURCE_IOS_EXTENSION - iOS notification extension */
    BlizzardEventSource[BlizzardEventSource["BLIZZARD_EVENT_SOURCE_IOS_EXTENSION"] = 3] = "BLIZZARD_EVENT_SOURCE_IOS_EXTENSION";
    /** BLIZZARD_EVENT_SOURCE_COMPOSER_MAP - Composer events sent to platform as dictionary and logged there */
    BlizzardEventSource[BlizzardEventSource["BLIZZARD_EVENT_SOURCE_COMPOSER_MAP"] = 4] = "BLIZZARD_EVENT_SOURCE_COMPOSER_MAP";
    BlizzardEventSource[BlizzardEventSource["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(BlizzardEventSource = exports.BlizzardEventSource || (exports.BlizzardEventSource = {}));
var AppType;
(function (AppType) {
    AppType[AppType["APP_TYPE_UNKNOWN"] = 0] = "APP_TYPE_UNKNOWN";
    /** APP_TYPE_WEB_DESKTOP - A desktop-optimized web browser app - use the os_type field on the event to determine the specific OS */
    AppType[AppType["APP_TYPE_WEB_DESKTOP"] = 1] = "APP_TYPE_WEB_DESKTOP";
    /** APP_TYPE_WEB_MOBILE - A mobile-optimized web browser app - use the os_type field on the event to determine the specific OS */
    AppType[AppType["APP_TYPE_WEB_MOBILE"] = 2] = "APP_TYPE_WEB_MOBILE";
    AppType[AppType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AppType = exports.AppType || (exports.AppType = {}));
function createBaseLoggedEventList() {
    return { events: [], sequentialItems: [] };
}
exports.LoggedEventList = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.events) {
            exports.LoggedEvent.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.sequentialItems) {
            exports.SequentialItem.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLoggedEventList();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.events.push(exports.LoggedEvent.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.sequentialItems.push(exports.SequentialItem.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseLoggedEventList();
        message.events =
            object.events?.map((e) => exports.LoggedEvent.fromPartial(e)) || [];
        message.sequentialItems =
            object.sequentialItems?.map((e) => exports.SequentialItem.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSequentialItem() {
    return { item: undefined };
}
exports.SequentialItem = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.item?.$case === "frameStart") {
            exports.FrameStart.encode(message.item.frameStart, writer.uint32(10).fork()).ldelim();
        }
        if (message.item?.$case === "event") {
            exports.Event.encode(message.item.event, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSequentialItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.item = {
                        $case: "frameStart",
                        frameStart: exports.FrameStart.decode(reader, reader.uint32()),
                    };
                    break;
                case 2:
                    message.item = {
                        $case: "event",
                        event: exports.Event.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSequentialItem();
        if (object.item?.$case === "frameStart" &&
            object.item?.frameStart !== undefined &&
            object.item?.frameStart !== null) {
            message.item = {
                $case: "frameStart",
                frameStart: exports.FrameStart.fromPartial(object.item.frameStart),
            };
        }
        if (object.item?.$case === "event" &&
            object.item?.event !== undefined &&
            object.item?.event !== null) {
            message.item = {
                $case: "event",
                event: exports.Event.fromPartial(object.item.event),
            };
        }
        return message;
    },
};
function createBaseLoggedEvent() {
    return { startFrame: undefined, events: [], endFrame: undefined };
}
exports.LoggedEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.startFrame !== undefined) {
            exports.FrameStart.encode(message.startFrame, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.events) {
            exports.Event.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.endFrame !== undefined) {
            exports.FrameEnd.encode(message.endFrame, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLoggedEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.startFrame = exports.FrameStart.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.events.push(exports.Event.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.endFrame = exports.FrameEnd.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseLoggedEvent();
        message.startFrame =
            object.startFrame !== undefined && object.startFrame !== null
                ? exports.FrameStart.fromPartial(object.startFrame)
                : undefined;
        message.events = object.events?.map((e) => exports.Event.fromPartial(e)) || [];
        message.endFrame =
            object.endFrame !== undefined && object.endFrame !== null
                ? exports.FrameEnd.fromPartial(object.endFrame)
                : undefined;
        return message;
    },
};
function createBaseFrameStart() {
    return {
        sessionId: new Uint8Array(),
        clientReferenceTs: "0",
        telemetrySessionId: new Uint8Array(),
        appVersion: 0,
        osVersion: 0,
        locale: 0,
        osType: 0,
        deviceModel: 0,
        appVariant: 0,
        userId: "",
        clientId: new Uint8Array(),
        priority: 0,
        localeFallback: "",
        osMinorVersion: 0,
        sequenceIdStart: 0,
        connectionDownloadBandwidthKbytesPerSecond: 0,
        deviceModelFallback: "",
        userAgent: new Uint8Array(),
        appBuildFallback: new Uint8Array(),
        osMinorVersionFallback: new Uint8Array(),
        appDataSaverMode: false,
        appStartupTypeFallback: new Uint8Array(),
        userGuid: new Uint8Array(),
        logQueueName: new Uint8Array(),
        appVersionString: "",
        osVersionString: "",
        blizzardSchemaVersion: "",
        appMultiWindowMode: false,
        appType: 0,
        browser: "",
        browserVersion: "",
        domain: "",
        referrer: "",
    };
}
exports.FrameStart = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.sessionId.length !== 0) {
            writer.uint32(10).bytes(message.sessionId);
        }
        if (message.clientReferenceTs !== "0") {
            writer.uint32(16).int64(message.clientReferenceTs);
        }
        if (message.telemetrySessionId.length !== 0) {
            writer.uint32(98).bytes(message.telemetrySessionId);
        }
        if (message.appVersion !== 0) {
            writer.uint32(29).fixed32(message.appVersion);
        }
        if (message.osVersion !== 0) {
            writer.uint32(37).fixed32(message.osVersion);
        }
        if (message.locale !== 0) {
            writer.uint32(40).int32(message.locale);
        }
        if (message.osType !== 0) {
            writer.uint32(48).int32(message.osType);
        }
        if (message.deviceModel !== 0) {
            writer.uint32(56).int32(message.deviceModel);
        }
        if (message.appVariant !== 0) {
            writer.uint32(64).int32(message.appVariant);
        }
        if (message.userId !== "") {
            writer.uint32(74).string(message.userId);
        }
        if (message.clientId.length !== 0) {
            writer.uint32(90).bytes(message.clientId);
        }
        if (message.priority !== 0) {
            writer.uint32(104).int32(message.priority);
        }
        if (message.localeFallback !== "") {
            writer.uint32(290).string(message.localeFallback);
        }
        if (message.osMinorVersion !== 0) {
            writer.uint32(256).int32(message.osMinorVersion);
        }
        if (message.sequenceIdStart !== 0) {
            writer.uint32(248).int32(message.sequenceIdStart);
        }
        if (message.connectionDownloadBandwidthKbytesPerSecond !== 0) {
            writer
                .uint32(272)
                .int32(message.connectionDownloadBandwidthKbytesPerSecond);
        }
        if (message.deviceModelFallback !== "") {
            writer.uint32(282).string(message.deviceModelFallback);
        }
        if (message.userAgent.length !== 0) {
            writer.uint32(306).bytes(message.userAgent);
        }
        if (message.appBuildFallback.length !== 0) {
            writer.uint32(314).bytes(message.appBuildFallback);
        }
        if (message.osMinorVersionFallback.length !== 0) {
            writer.uint32(322).bytes(message.osMinorVersionFallback);
        }
        if (message.appDataSaverMode === true) {
            writer.uint32(328).bool(message.appDataSaverMode);
        }
        if (message.appStartupTypeFallback.length !== 0) {
            writer.uint32(338).bytes(message.appStartupTypeFallback);
        }
        if (message.userGuid.length !== 0) {
            writer.uint32(346).bytes(message.userGuid);
        }
        if (message.logQueueName.length !== 0) {
            writer.uint32(354).bytes(message.logQueueName);
        }
        if (message.appVersionString !== "") {
            writer.uint32(362).string(message.appVersionString);
        }
        if (message.osVersionString !== "") {
            writer.uint32(370).string(message.osVersionString);
        }
        if (message.blizzardSchemaVersion !== "") {
            writer.uint32(378).string(message.blizzardSchemaVersion);
        }
        if (message.appMultiWindowMode === true) {
            writer.uint32(384).bool(message.appMultiWindowMode);
        }
        if (message.appType !== 0) {
            writer.uint32(392).int32(message.appType);
        }
        if (message.browser !== "") {
            writer.uint32(402).string(message.browser);
        }
        if (message.browserVersion !== "") {
            writer.uint32(410).string(message.browserVersion);
        }
        if (message.domain !== "") {
            writer.uint32(418).string(message.domain);
        }
        if (message.referrer !== "") {
            writer.uint32(426).string(message.referrer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFrameStart();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sessionId = reader.bytes();
                    break;
                case 2:
                    message.clientReferenceTs = longToString(reader.int64());
                    break;
                case 12:
                    message.telemetrySessionId = reader.bytes();
                    break;
                case 3:
                    message.appVersion = reader.fixed32();
                    break;
                case 4:
                    message.osVersion = reader.fixed32();
                    break;
                case 5:
                    message.locale = reader.int32();
                    break;
                case 6:
                    message.osType = reader.int32();
                    break;
                case 7:
                    message.deviceModel = reader.int32();
                    break;
                case 8:
                    message.appVariant = reader.int32();
                    break;
                case 9:
                    message.userId = reader.string();
                    break;
                case 11:
                    message.clientId = reader.bytes();
                    break;
                case 13:
                    message.priority = reader.int32();
                    break;
                case 36:
                    message.localeFallback = reader.string();
                    break;
                case 32:
                    message.osMinorVersion = reader.int32();
                    break;
                case 31:
                    message.sequenceIdStart = reader.int32();
                    break;
                case 34:
                    message.connectionDownloadBandwidthKbytesPerSecond = reader.int32();
                    break;
                case 35:
                    message.deviceModelFallback = reader.string();
                    break;
                case 38:
                    message.userAgent = reader.bytes();
                    break;
                case 39:
                    message.appBuildFallback = reader.bytes();
                    break;
                case 40:
                    message.osMinorVersionFallback = reader.bytes();
                    break;
                case 41:
                    message.appDataSaverMode = reader.bool();
                    break;
                case 42:
                    message.appStartupTypeFallback = reader.bytes();
                    break;
                case 43:
                    message.userGuid = reader.bytes();
                    break;
                case 44:
                    message.logQueueName = reader.bytes();
                    break;
                case 45:
                    message.appVersionString = reader.string();
                    break;
                case 46:
                    message.osVersionString = reader.string();
                    break;
                case 47:
                    message.blizzardSchemaVersion = reader.string();
                    break;
                case 48:
                    message.appMultiWindowMode = reader.bool();
                    break;
                case 49:
                    message.appType = reader.int32();
                    break;
                case 50:
                    message.browser = reader.string();
                    break;
                case 51:
                    message.browserVersion = reader.string();
                    break;
                case 52:
                    message.domain = reader.string();
                    break;
                case 53:
                    message.referrer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseFrameStart();
        message.sessionId = object.sessionId ?? new Uint8Array();
        message.clientReferenceTs = object.clientReferenceTs ?? "0";
        message.telemetrySessionId = object.telemetrySessionId ?? new Uint8Array();
        message.appVersion = object.appVersion ?? 0;
        message.osVersion = object.osVersion ?? 0;
        message.locale = object.locale ?? 0;
        message.osType = object.osType ?? 0;
        message.deviceModel = object.deviceModel ?? 0;
        message.appVariant = object.appVariant ?? 0;
        message.userId = object.userId ?? "";
        message.clientId = object.clientId ?? new Uint8Array();
        message.priority = object.priority ?? 0;
        message.localeFallback = object.localeFallback ?? "";
        message.osMinorVersion = object.osMinorVersion ?? 0;
        message.sequenceIdStart = object.sequenceIdStart ?? 0;
        message.connectionDownloadBandwidthKbytesPerSecond =
            object.connectionDownloadBandwidthKbytesPerSecond ?? 0;
        message.deviceModelFallback = object.deviceModelFallback ?? "";
        message.userAgent = object.userAgent ?? new Uint8Array();
        message.appBuildFallback = object.appBuildFallback ?? new Uint8Array();
        message.osMinorVersionFallback =
            object.osMinorVersionFallback ?? new Uint8Array();
        message.appDataSaverMode = object.appDataSaverMode ?? false;
        message.appStartupTypeFallback =
            object.appStartupTypeFallback ?? new Uint8Array();
        message.userGuid = object.userGuid ?? new Uint8Array();
        message.logQueueName = object.logQueueName ?? new Uint8Array();
        message.appVersionString = object.appVersionString ?? "";
        message.osVersionString = object.osVersionString ?? "";
        message.blizzardSchemaVersion = object.blizzardSchemaVersion ?? "";
        message.appMultiWindowMode = object.appMultiWindowMode ?? false;
        message.appType = object.appType ?? 0;
        message.browser = object.browser ?? "";
        message.browserVersion = object.browserVersion ?? "";
        message.domain = object.domain ?? "";
        message.referrer = object.referrer ?? "";
        return message;
    },
};
function createBaseEvent() {
    return {
        eventName: "0",
        offsetTsStart: 0,
        sequenceNumber: 0,
        payloadIdentifier: 0,
        payloadBytes: new Uint8Array(),
        payloadProto: new Uint8Array(),
        payloadJson: new Uint8Array(),
        deviceConnectivity: 0,
        connectionDownloadBandwidthBps: "0",
        eventSamplingRate: 0,
        userSamplingRate: 0,
        pageViewId: "0",
        pageTabType: 0,
        isInCall: false,
        blizzardEventSource: 0,
    };
}
exports.Event = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.eventName !== "0") {
            writer.uint32(8).int64(message.eventName);
        }
        if (message.offsetTsStart !== 0) {
            writer.uint32(16).int32(message.offsetTsStart);
        }
        if (message.sequenceNumber !== 0) {
            writer.uint32(48).int32(message.sequenceNumber);
        }
        if (message.payloadIdentifier !== 0) {
            writer.uint32(32).int32(message.payloadIdentifier);
        }
        if (message.payloadBytes.length !== 0) {
            writer.uint32(42).bytes(message.payloadBytes);
        }
        if (message.payloadProto.length !== 0) {
            writer.uint32(90).bytes(message.payloadProto);
        }
        if (message.payloadJson.length !== 0) {
            writer.uint32(98).bytes(message.payloadJson);
        }
        if (message.deviceConnectivity !== 0) {
            writer.uint32(64).int32(message.deviceConnectivity);
        }
        if (message.connectionDownloadBandwidthBps !== "0") {
            writer.uint32(72).int64(message.connectionDownloadBandwidthBps);
        }
        if (message.eventSamplingRate !== 0) {
            writer.uint32(105).double(message.eventSamplingRate);
        }
        if (message.userSamplingRate !== 0) {
            writer.uint32(113).double(message.userSamplingRate);
        }
        if (message.pageViewId !== "0") {
            writer.uint32(120).int64(message.pageViewId);
        }
        if (message.pageTabType !== 0) {
            writer.uint32(136).int32(message.pageTabType);
        }
        if (message.isInCall === true) {
            writer.uint32(128).bool(message.isInCall);
        }
        if (message.blizzardEventSource !== 0) {
            writer.uint32(144).int32(message.blizzardEventSource);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.eventName = longToString(reader.int64());
                    break;
                case 2:
                    message.offsetTsStart = reader.int32();
                    break;
                case 6:
                    message.sequenceNumber = reader.int32();
                    break;
                case 4:
                    message.payloadIdentifier = reader.int32();
                    break;
                case 5:
                    message.payloadBytes = reader.bytes();
                    break;
                case 11:
                    message.payloadProto = reader.bytes();
                    break;
                case 12:
                    message.payloadJson = reader.bytes();
                    break;
                case 8:
                    message.deviceConnectivity = reader.int32();
                    break;
                case 9:
                    message.connectionDownloadBandwidthBps = longToString(reader.int64());
                    break;
                case 13:
                    message.eventSamplingRate = reader.double();
                    break;
                case 14:
                    message.userSamplingRate = reader.double();
                    break;
                case 15:
                    message.pageViewId = longToString(reader.int64());
                    break;
                case 17:
                    message.pageTabType = reader.int32();
                    break;
                case 16:
                    message.isInCall = reader.bool();
                    break;
                case 18:
                    message.blizzardEventSource = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseEvent();
        message.eventName = object.eventName ?? "0";
        message.offsetTsStart = object.offsetTsStart ?? 0;
        message.sequenceNumber = object.sequenceNumber ?? 0;
        message.payloadIdentifier = object.payloadIdentifier ?? 0;
        message.payloadBytes = object.payloadBytes ?? new Uint8Array();
        message.payloadProto = object.payloadProto ?? new Uint8Array();
        message.payloadJson = object.payloadJson ?? new Uint8Array();
        message.deviceConnectivity = object.deviceConnectivity ?? 0;
        message.connectionDownloadBandwidthBps =
            object.connectionDownloadBandwidthBps ?? "0";
        message.eventSamplingRate = object.eventSamplingRate ?? 0;
        message.userSamplingRate = object.userSamplingRate ?? 0;
        message.pageViewId = object.pageViewId ?? "0";
        message.pageTabType = object.pageTabType ?? 0;
        message.isInCall = object.isInCall ?? false;
        message.blizzardEventSource = object.blizzardEventSource ?? 0;
        return message;
    },
};
function createBaseFrameEnd() {
    return { lastSequenceNumber: 0 };
}
exports.FrameEnd = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.lastSequenceNumber !== 0) {
            writer.uint32(8).int32(message.lastSequenceNumber);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFrameEnd();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.lastSequenceNumber = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseFrameEnd();
        message.lastSequenceNumber = object.lastSequenceNumber ?? 0;
        return message;
    },
};
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=framedevent.js.map